import { type ReactNode } from 'react';
import { cn } from '~/lib/utils';

interface NavbarProps {
    children: ReactNode
    className: string
}

const Navbar = ({ children, className, ...props }: NavbarProps) => {
    return (
        <nav className={cn("border-grid border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60", className)} {...props}>
            { children }
        </nav>
    )
}

export { Navbar }